"use client";

import { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImageGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const images = [{
    id: 1,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/financial_team_collaboration.png",
    alt: "Financial team collaborating on strategic planning",
    caption: "Strategic Financial Planning"
  }, {
    id: 2,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_office_environment.png",
    alt: "Modern office environment for financial services",
    caption: "Contemporary Workspace"
  }, {
    id: 3,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/team_meeting_discussion.png",
    alt: "Professional team meeting and discussion",
    caption: "Expert Team Collaboration"
  }, {
    id: 4,
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/financial_analysis_workspace.png",
    alt: "Financial analysis and data workspace",
    caption: "Data-Driven Insights"
  }];
  return;
}